import React from 'react';
import PublicHeader from './PublicHeader';

export default function ReaderAppreciationGuide() {
  return <div className="public-design">
    <PublicHeader audience="author" />
    <main className="public-container public-section public-story">
      <p className="public-eyebrow">A guide for Circle Authors</p>
      <h1>Reader Appreciation Program</h1>
      <p>Thank your readers with special pricing in your Bookish Circle shop. Reader Appreciation is an optional program that lets participating Circle Authors offer discounts to signed-in Circle Readers.</p>

      <section>
        <h2>What readers receive</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>$1 off each ebook priced $3 or more.</strong> Ebooks priced below $3 keep their normal price.</li>
          <li><strong>10% off physical products,</strong> including physical books and bookish merchandise.</li>
        </ul>
        <p>For example, a $4.99 ebook becomes $3.99, and a $20 physical book becomes $18. Discounts apply to product prices before shipping; shipping charges stay the same.</p>
      </section>

      <section>
        <h2>Who qualifies</h2>
        <p>Readers must be signed in to their Bookish Circle Reader account to receive the discount from a participating author. Guest checkout does not qualify. Discounts apply to purchases through your Bookish Circle shop.</p>
      </section>

      <section>
        <h2>Keep your normal retail prices</h2>
        <p>Continue entering your usual prices for books, formats, and merchandise. Bookish Circle automatically shows eligible readers their discounted price and applies it at checkout. You do not need to lower your catalog prices or create a coupon.</p>
        <p>By joining, you agree to sell eligible products at these discounted prices. Consider those prices when planning your earnings.</p>
      </section>

      <section>
        <h2>How to join or leave</h2>
        <p>You need an active Circle Author membership to join. Participation is off by default.</p>
        <ol className="list-decimal pl-6 space-y-2">
          <li>Open <strong>Membership &amp; Billing</strong> in your Author Portal.</li>
          <li>Find <strong>Reader Appreciation Program</strong> and check the agreement box.</li>
          <li>Select <strong>Save participation</strong> to turn on the discounts.</li>
        </ol>
        <p>You can leave at any time by unchecking the agreement box and selecting Save participation. Simply reading this guide does not enroll you.</p>
        <p>You can close this tab to return to your program settings.</p>
      </section>
    </main>
  </div>;
}
